<template lang='pug'>
  v-container(fluid)
    v-row.justify-center
      v-col.d-flex.justify-center
        div
          router-link.link-light(:to='agreementRoute.terms') {{agreementResource.terms}}
          |&nbsp;/&nbsp;
          router-link.link-light(:to='agreementRoute.privacy') {{agreementResource.privacy}}
          |&nbsp;/&nbsp;
          router-link.link-light(:to='quickytoolsRoute.credits') {{commonResource.credits}}
</template>

<script>
import appRoutes from '@/router/routes'
import agreementResource from '@/resources/agreement'
import commonResource from '@/resources/common'

export default {
  name: 'StaticContentFooter',
  data: () => ({
    agreementRoute: appRoutes.agreement,
    quickytoolsRoute: appRoutes.quickytools,
    agreementResource,
    commonResource
  })
}
</script>
